
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import ElementTipTap from '@/components/ElementTipTap/index.vue';

@Component({
  name: 'BasicForm',
  components: {
    ElementTipTap,
  },
})
export default class extends Vue {
  private formData = {
    deliveryFee: '',
    deliveryFreeStatus: false,
    deliveryFreeTerms: '',
    detailDescription: '',
  };

  get industry() {
    return UserModule.industry;
  }

  private rules = {
    deliveryFee: [
      { required: true, message: '배송비를 입력하세요.', trigger: 'blur' },
    ],
    detailDescription: [
      { required: true, message: '시설분류를 선택하세요.', trigger: 'blur' },
    ],
  };

  private defaultDeliveryInfo = '<h1><strong>배송정보</strong></h1><p>오후 4시 이전 주문은 당일 발송, 택배사의 특별한 경우가 없을 경우 다음날 받아 보실 수 있습니다.</p><p>(택배사의 사정이 있거나, 주문량이 많을 경우 2~3일정도 소요될 수도 있습니다.)</p><p><br class="ProseMirror-trailingBreak"></p><ul><li><p>3만원 이상은 무료배송 입니다.</p></li></ul><ul><li><p>제주도 및 도서, 산간지방 1,500원 추가적용</p></li></ul><ul><li><p>택배사 :</p></li></ul><ul><li><p>토요일, 일요일 주문은 월요일에 발송됩니다.</p></li></ul>';

  private handleChangeEditor(value: any) {
    this.formData.detailDescription = value;
  }

  private handleDefaultCk() {
    this.defaultCk = !this.defaultCk;
    if (this.defaultCk) this.formData.detailDescription = this.defaultDeliveryInfo;
    else this.formData.detailDescription = '';
  }

  private defaultCk = false;
}
